import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  contractors: [],
  error: null,
  message: '',
};

const Contractor = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CONTRACTOR_REQUEST:
    case actionTypes.DELETE_CONTRACTOR_REQUEST:
    case actionTypes.UPLOAD_CONTRACTOR_REQUEST:
    case actionTypes.MULTIDELETE_CONTRACTOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_CONTRACTOR_SUCCESS:
    case actionTypes.DELETE_CONTRACTOR_SUCCESS:
    case actionTypes.UPLOAD_CONTRACTOR_SUCCESS:
    case actionTypes.MULTIDELETE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_CONTRACTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        contractors: action.payload,

      }
    case actionTypes.GET_CONTRACTOR_FAILURE:
    case actionTypes.UPDATE_CONTRACTOR_FAILURE:
    case actionTypes.DELETE_CONTRACTOR_FAILURE:
    case actionTypes.UPLOAD_CONTRACTOR_FAILURE:
    case actionTypes.MULTIDELETE_CONTRACTOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Contractor;
